import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Test Product',
  ProductCode: 'trhp28',
  Description:
    '<p>Test Product</p>',
  Credits:
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.\n',
};
